<template>
  <div
    class="flight-table-skeleton"
    role="status"
    aria-busy="true"
    :aria-label="$t('loadingflights.loadingTable')"
  >
    <div
      v-for="n in rowCount"
      :key="n"
      class="row-flight skeleton-row"
    >
      <div class="cell id"><span class="skeleton-bar skeleton-bar--sm" /></div>
      <div class="cell airline"><span class="skeleton-bar skeleton-bar--lg" /></div>
      <div class="cell airlineCode"><span class="skeleton-bar skeleton-bar--sm" /></div>
      <div class="cell flightNumber"><span class="skeleton-bar skeleton-bar--sm" /></div>
      <div class="cell arrival-departure"><span class="skeleton-bar skeleton-bar--md" /></div>
      <div class="cell city"><span class="skeleton-bar skeleton-bar--lg" /></div>
      <div class="cell sdtDate"><span class="skeleton-bar skeleton-bar--md" /></div>
      <div class="cell scheduled"><span class="skeleton-bar skeleton-bar--md" /></div>
      <div class="cell estimated"><span class="skeleton-bar skeleton-bar--md" /></div>
      <div class="cell gate"><span class="skeleton-bar skeleton-bar--sm" /></div>
      <div class="cell claim"><span class="skeleton-bar skeleton-bar--sm" /></div>
      <div class="cell status"><span class="skeleton-bar skeleton-bar--md" /></div>
      <div class="cell"><span class="skeleton-bar skeleton-bar--lg" /></div>
      <div class="cell action"><span class="skeleton-bar skeleton-bar--icon" /></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FlightTableSkeleton',
  props: {
    rowCount: {
      type: Number,
      default: 10
    }
  }
};
</script>

<style scoped lang="scss">
.flight-table-skeleton {
  width: 100%;
  min-width: 1180px;
}

.skeleton-row {
  width: 100%;
  min-height: 50px;
  display: flex;
  background-color: #fff;
  border-bottom: 1px solid hsl(211, 30%, 92%);

  &:nth-child(even) {
    background-color: hsl(211, 55%, 98%);
  }

  .cell {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 8px;
    font-size: 12px;

    &.id { min-width: 80px; max-width: 80px; }
    &.airline { min-width: 230px; max-width: 230px; justify-content: flex-start; }
    &.airlineCode, &.flightNumber, &.scheduled, &.estimated, &.gate, &.claim, &.action {
      min-width: 80px;
      max-width: 120px;
    }
    &.sdtDate {
      min-width: 104px;
      max-width: 104px;
    }
    &.city { min-width: 200px; max-width: 200px; }
    &.status { min-width: 140px; max-width: 140px; }
    &.arrival-departure { min-width: 90px; max-width: 110px; }
  }

  .skeleton-bar {
    display: block;
    height: 12px;
    border-radius: 4px;
    background: linear-gradient(
      90deg,
      hsl(211, 40%, 92%) 0%,
      hsl(211, 50%, 88%) 50%,
      hsl(211, 40%, 92%) 100%
    );
    background-size: 200% 100%;
    animation: skeleton-pulse 1.4s ease-in-out infinite;

    &--sm { width: 48px; }
    &--md { width: 72px; }
    &--lg { width: 120px; }
    &--icon {
      width: 28px;
      height: 28px;
      border-radius: 8px;
    }
  }
}

@keyframes skeleton-pulse {
  0% { background-position: 100% 0; }
  100% { background-position: -100% 0; }
}
</style>
